import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { connect } from 'react-redux'
import { withRouter, NavLink } from 'react-router-dom'
import { isValidElementType } from 'react-is'
import URLSearchParams from '@ungap/url-search-params'
import { redirectToLogin, filterAppEntitlementsByNoAccessFlag } from '../../utils'
import { fetchEntitlements, switchAccountIndex } from '../../actions'
import AppBar from './AppBar'
import HelpIcon from './HelpIcon'
import './AppBarNav.css'
import AppBarSideNav from './AppBarSideNav'

export class AppBarNav extends Component {
  state = {
    hoverClass: '',
  }

  logoutHandler = (e) => {
    e.preventDefault()
    this.props.showGlobalMask()
    localStorage.setItem('selectedAccount', '') // will use default csp account
    setTimeout(() => {
      window.location.replace('/saml/logout')
    }, 100)
  }

  onCortexEvent = (e) => {
    // console.log(e.detail)
  }

  onAccountSelected = (e) => {
    const cspId = e.detail && +e.detail.key
    const { supportAccountIds, setSupportAccountIndexHandler } = this.props
    if (cspId && supportAccountIds && supportAccountIds.length) {
      const index = supportAccountIds.findIndex(a => a.accountid === cspId)
      if (index >= 0) {
        setSupportAccountIndexHandler(index)
      }
    }
  }

  loginHandler = (e) => {
    e.preventDefault()
    redirectToLogin()
    return false
  }

  onScrollHandler = () => {
    const hoverClass = window.scrollY > 10 ? 'hover' : ''
    if (hoverClass !== this.state.hoverClass) {
      this.setState({ hoverClass })
    }
  }

  navigateHomeHandler = () => {
    const { history, defaultPath } = this.props
    if (history.location.pathname !== defaultPath) {
      const urlQueries = new URLSearchParams(history.location.search)
      const path = !defaultPath.includes('?') && urlQueries.get('instance') ?
        `${defaultPath}?${urlQueries.toString()}` : defaultPath
      history.push(path)
    }
  }

  navigateProfileHandler = () => {
    const { history } = this.props
    const view_profile = '/account-info'
    if (history.location.pathname !== view_profile) {
      history.push(view_profile)
    }
  }

  componentDidMount() {
    window.addEventListener('scroll', this.onScrollHandler)
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.onScrollHandler)
  }

  shouldComponentUpdate(nextProps, nextState) {
    return true
  }

  renderNavUtils() {
    const { navUtils } = this.props
    if (!navUtils || !Array.isArray(navUtils) || navUtils.length === 0) {
      return null
    }
    const {
      navigateHome,
      isAuthenticated,
      selectedAccount,
      supportAccountIds,
      fetchEntitlements,
      history,
    } = this.props
    const props = {
      navigateHome,
      isAuthenticated,
      selectedAccount,
      supportAccountIds,
      fetchEntitlements,
      history,
    }
    const utils = []
    const pushItem = (item) => {
      if (React.isValidElement(item)) {
        utils.push(React.cloneElement(item, props))
      }
      else if (isValidElementType(item)) {
        const Item = item
        utils.push(<Item {...props} />)
      }
      else {
        // eslint-disable-next-line no-console
        console.error('something in navUtils is not supported', navUtils)
        throw new Error('something in navUtils is not supported')
      }
    }
    navUtils.forEach(pushItem)

    return utils.map((item, i) => (
      <li className='nav-item'
        key={`${item.id || item.name || item.constructor.displayName || 'item'}-${i}`}
      >{item}</li>
    ))
  }

  filteredEntitlements() {
    const { isAppPortal, entitledAppsList } = this.props
    let appList = entitledAppsList.filter(app => app.entitled && !app.no_app_tile_ui)
    if (appList.every(app => !app.tenants || !app.tenants.length)) {
      return {}
    }
    if (isAppPortal) {
      appList = filterAppEntitlementsByNoAccessFlag(appList)
    }
    const apps = appList.reduce((o, app) => {
      // treat url start with # as empty url
      const cloneTenant = t => ({ ...t, url: t.url && t.url.startsWith('#') ? '' : t.url })
      // shallow clone due to app-switcher could mutate the tenants
      const tenants = app.tenants && Array.isArray(app.tenants) ? app.tenants.map(cloneTenant) : []
      o[app.name] = { ...app, tenants }
      return o
    }, {})
    return apps
  }

  renderTabs() {
    const { navItems } = this.props
    if (!navItems || !navItems.length) {
      return null
    }
    const {
      navigateHome,
      isAuthenticated,
      selectedAccount,
      supportAccountIds,
      fetchEntitlements,
      history,
    } = this.props
    const props = {
      navigateHome,
      isAuthenticated,
      selectedAccount,
      supportAccountIds,
      fetchEntitlements,
      history,
    }
    const navTabs = []
    navItems.forEach(navItem => {
      if (React.isValidElement(navItem)) {
        navTabs.push(React.isValidElement(React.cloneElement(navItem, props)))
      }
      else if (isValidElementType(navItem)) {
        const Item = navItem
        navTabs.push(<Item {...props} />)
      }
      else if (navItem.path) {
        navTabs.push(
          <NavLink
            to={{
              pathname: navItem.path,
              search: window.location.search,
            }}
            key={navItem.path}
            className='nav-link'
            activeClassName='active'
          >
            {navItem.text}
          </NavLink>
        )
      }
    })
    return navTabs.map((item, i) => (
      <li className='nav-item'
        key={`${item.key || item.id || item.name || 'nav-item'}-${i}`}
      >{item}</li>
    ))
  }

  render() {
    const {
      name,
      logoImg,
      logoImgCompact,
      navigateHome,
      supportAccountIds,
      isAuthenticated,
      selectedAccount,
      user_email,
      user,
      history,
      notonorafter,
      fetchEntitlements,
      entitlementFetching: fetching,
      helpLink,
      appBarProps,
      navItems
    } = this.props

    if (!isAuthenticated) {
      if (appBarProps.hideAppBar) {
        return null
      }
      return <div className={classNames('cortex-app-bar-mock', this.state.hoverClass)}>
        <img className='app-bar-logo' alt='' src={logoImg} onClick={this.navigateHomeHandler} />
        <ul id='utility-bar' className='utility-bar'>
          <li className='nav-item dropdown nav-item-user'>
            <a
              className='nav-link nav-login-link'
              href='/saml/login'
              onClick={this.loginHandler}
            >Sign In</a>
          </li>
        </ul>
      </div>
    }

    const props = {
      name,
      logoImg,
      logoImgCompact,
      appEntitlements: this.filteredEntitlements(), // filter and shallow clone prevent mutation
      supportAccountIds: supportAccountIds ? [...supportAccountIds] : [], // shallow clone prevent mutation
      isAuthenticated,
      selectedAccount,
      user_email,
      user,
      notonorafter,
      fetchEntitlements,
      fetching,
      history,
      canSwitchAccount: navigateHome,
      onNavigateHome: this.navigateHomeHandler,
      onNavigateHub: navigateHome ? this.navigateHomeHandler : undefined,
      onNavigateProfile: navigateHome ? this.navigateProfileHandler : undefined,
      className: classNames('cortex-app-bar', this.state.hoverClass),
      onAccountSelected: this.onAccountSelected,
      onCortexEvent: this.onCortexEvent,
      onLogout: this.logoutHandler,
      ...appBarProps,
    }

    const appBarSideNavProps = {
      navItems,
      helpLink,
      onLogout: this.logoutHandler,
      userName: user,
      companyName: name,
      email: user_email,
      selectedAccount: supportAccountIds[selectedAccount]
    }

    const { isVertical } = appBarProps
    return <AppBar {...props}>
      <div className={isVertical ? 'app-bar-inner-vertical' : 'app-bar-inner'}>
        {!isVertical ? (<ul id='app-nav' className='app-nav'>
          {this.renderTabs()}
        </ul>) : (<AppBarSideNav {...appBarSideNavProps} ></AppBarSideNav>)}
        {isVertical ? null :
          (<ul id='utility-bar' className='utility-bar'>
            {this.renderNavUtils()}
            <li className='nav-item'>
              <a
                className='nav-link'
                href={helpLink}
                rel='noopener noreferrer'
                target='_blank'
                data-toggle='tooltip'
                data-placement='bottom'
                title='Help'
                data-original-title='Help'
              >
                <HelpIcon width='16px' height='16px'/>
              </a>
            </li>
          </ul>)
        }
      </div>
    </AppBar>
  }
}

AppBarNav.propTypes = {
  navItems: PropTypes.array,
  navUtils: PropTypes.array,
  name: PropTypes.string,
  isAppPortal: PropTypes.bool,
  navigateHome: PropTypes.bool,
  context: PropTypes.object,
  logoImg: PropTypes.node,
  logoImgCompact: PropTypes.node,
  entitledAppsList: PropTypes.array,
  isAuthenticated: PropTypes.bool,
  user: PropTypes.string,
  user_email: PropTypes.string,
  selectedAccount: PropTypes.number,
  supportAccountIds: PropTypes.array,
  notonorafter: PropTypes.string,
  setSupportAccountIndexHandler: PropTypes.func,
  defaultPath: PropTypes.string,
  entitlementFetching: PropTypes.bool,
  fetchEntitlements: PropTypes.func,
  showGlobalMask: PropTypes.func,
  history: PropTypes.object,
  helpLink: PropTypes.oneOfType(
    [
      PropTypes.string,
      PropTypes.array
    ]
  ),
  appBarProps: PropTypes.object,
}

AppBarNav.defaultProps = {
  navItems: [],
  navUtils: [],
  entitledAppsList: [],
  supportAccountIds: [],
  name: 'App',
  isAuthenticated: false,
  entitlementFetching: false,
  defaultPath: '/',
  helpLink: 'https://docs.paloaltonetworks.com/hub',
  appBarProps: { isVertical: false },

}

const mapStateToProps = ({ isAuthenticated,
  user_email,
  user,
  entitledAppsList,
  supportAccountIds,
  selectedAccount,
  entitlementFetching,
  notonorafter,
  appBarProps,
}) => ({
  isAuthenticated,
  user_email,
  user,
  entitledAppsList,
  supportAccountIds,
  selectedAccount,
  entitlementFetching,
  notonorafter,
  ...appBarProps
})

const mapDispatchToProps = (dispatch) => ({
  fetchEntitlements: (options) => dispatch(fetchEntitlements(options)),
  showGlobalMask: () => dispatch({ type: 'GLOBAL_LOADING_MASK_ON' }),
  setSupportAccountIndexHandler: (id) => {
    dispatch(switchAccountIndex(id))
  },
})

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  const { selectedAccount } = stateProps
  return {
    ...ownProps,
    ...stateProps,
    ...dispatchProps,
    fetchEntitlements: (id) => dispatchProps.fetchEntitlements({ selectedAccount: typeof id === 'number' ? id : selectedAccount }),
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps, mergeProps)(AppBarNav))
